import decode from 'jwt-decode';
import type { IUserJWT } from 'src/types/types';

const decodeUserJWT = (userToken: 'LOADING' | { token: string | null }): IUserJWT | null => {
	if (
		typeof window !== 'undefined' &&
		userToken !== 'LOADING' &&
		userToken.token &&
		userToken.token.length
	) {
		return decode(`${userToken.token}`.replace(/bearer\s+/i, ''));
	}
	return null;
};
const decodeUserJWTV2 = (token: string): IUserJWT => decode(`${token}`.replace(/bearer\s+/i, ''));

const isCountablePage = (url: string) => {
	return url.includes('/d411id/') === true || url.includes('/d411-id/') === true;
	// this should be if pathname includes d411id
};

export { decodeUserJWT, decodeUserJWTV2, isCountablePage };
